import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { breakpoints } from '@chegg-ui/theme';
export function getCloudinaryUrl(imageCdnHost, publicId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var defaultOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ['q_auto', 'f_auto'];
  return "//".concat(imageCdnHost, "/image/upload/").concat(Array.from(new Set([].concat(_toConsumableArray(defaultOptions), _toConsumableArray(options)))).sort().join(','), "/").concat(publicId);
}
export var getSrcSets = function getSrcSets(cdnHost, url, maxWidth) {
  var srcSetConfigs = [];

  for (var width = 200; width <= maxWidth; width += 200) {
    srcSetConfigs.push("".concat(getCloudinaryUrl(cdnHost, url, ["w_".concat(width), 'c_scale']), " ").concat(width, "w"));
  }

  return srcSetConfigs.join(',');
};
export var ImageScalingMode;

(function (ImageScalingMode) {
  ImageScalingMode["Original"] = "Original";
  ImageScalingMode["Fill"] = "Fill";
})(ImageScalingMode || (ImageScalingMode = {}));

export function createCloudinaryConfig(asset) {
  var _default = asset["default"],
      xl = asset.xl,
      lg = asset.lg,
      md = asset.md,
      sm = asset.sm,
      cdnHost = asset.cdnHost,
      onError = asset.onError,
      onLoad = asset.onLoad,
      lazy = asset.lazy;
  return {
    cdnHost: cdnHost,
    alt: _default.alt,
    src: _default.formattedPublicId || _default.publicId,
    onError: onError,
    onLoad: onLoad,
    lazy: lazy,
    srcConfig: {
      xl: xl && (xl.formattedPublicId || xl.publicId),
      lg: lg && (lg.formattedPublicId || lg.publicId),
      md: md && (md.formattedPublicId || md.publicId),
      sm: sm && (sm.formattedPublicId || sm.publicId)
    }
  };
}
export var breakpointImageMediaMap = {
  xl: "(min-width: ".concat(breakpoints['xl'].min, ")"),
  lg: "(max-width: ".concat(breakpoints['lg'].max, ")"),
  md: "(max-width: ".concat(breakpoints['md'].max, ")"),
  sm: "(max-width: ".concat(breakpoints['sm'].max, ")"),
  "default": ''
};
export function getImageSizesConfig() {
  var sizesConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ['sm', 'md', 'lg', 'xl', 'default'].map(function (breakpoint) {
    return sizesConfig[breakpoint] ? "".concat(breakpointImageMediaMap[breakpoint], " ").concat(sizesConfig[breakpoint]) : '';
  }).filter(function (size) {
    return !!size;
  }).join(', ');
}